import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
/**
 * a component can subscibe to this.emitter$ and decide if he needs to do some action when an event arrives: e.g. when component A opens (eventName OPEN, forwardedFor A), then component B should close
 * a component can use this.toggleEvent(e) to forward his own event: e.g. component A could tell another component B that he opened, so component B can take action if necessary (e.g. close or do something else)
 *
 * also the inverse behaviour is possible: a component A or sevice A could use this ToggleEventService to force another component B (who is listening) to e.g. open himself (eventName OPEN_COMMAND, forwardedFor B)
 * 
 * forwardedFor is name of component that is linked to the event e.g. 'measure', 'elevation-profile' (by convention we could use the first part of the component's filename e.g. for 'elevation-profile.component.ts' it would become 'elevation-profile')
 *  - the string in forwardedFor will be the component A's own name in case of e.g. event OPEN
 *  - but when component A will send e.g. event OPEN_COMMAND to component B, then the string in forwardedFor should be the name of the other component B
 * 
 * eventName is the type of event that happened e.g. ToggleEventNameType.OPEN
 */

export enum ToggleEventNameType {
  OPEN, CLOSE, ACTIVE, INACTIVE, VISIBLE, INVISIBLE, UPDATE, DARK_THEME, LIGHT_THEME, FILE_IMPORT,
  OPEN_COMMAND, CLOSE_COMMAND, ACTIVE_COMMAND, INACTIVE_COMMAND, UPDATE_COMMAND
};
export type ToggleEventType = {
  forwardedFor: string;
  eventName: ToggleEventNameType;
};
@Injectable({
  providedIn: 'root',
})
export class ToggleEventService {
  private _emitter = new Subject<ToggleEventType>();
  public emitter$ = this._emitter as Observable<ToggleEventType>;
  public toggleEvent(toggleEvent: ToggleEventType): void {
    this._emitter.next(toggleEvent);
  }
}
